/* Smooth open / close for the collection "Sort by" <details> dropdown.
 *
 *  - Opening is left to the native <summary> toggle; CSS animates the list in.
 *  - Closing (clicking the toggle while open, an outside click, or Escape)
 *    plays a close animation first, then removes [open].
 *
 * Listeners are delegated on document and guarded by a global flag, so this
 * survives the toolbar's AJAX re-renders and never binds twice.
 */
(function () {
  if (window.__rpCollectionSortInit) return;
  window.__rpCollectionSortInit = true;

  // Keep in sync with the CSS animation duration (CollectionSortOut).
  var CLOSE_MS = 180;

  function animateClose(details) {
    if (!details || details.classList.contains('is-closing')) return;
    details.classList.add('is-closing');
    window.setTimeout(function () {
      details.classList.remove('is-closing');
      details.removeAttribute('open');
    }, CLOSE_MS);
  }

  function openDropdowns() {
    return document.querySelectorAll('details[data-collection-sort][open]');
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var summary = target.closest ? target.closest('.CollectionSort__Toggle') : null;

    if (summary) {
      var details = summary.closest('details[data-collection-sort]');
      // If already open, intercept the native instant-close and animate instead.
      if (details && details.hasAttribute('open') && !details.classList.contains('is-closing')) {
        event.preventDefault();
        animateClose(details);
      }
      return; // opening is handled by the native <details> toggle
    }

    // A click anywhere else closes any open dropdown — unless the click is
    // inside it (e.g. choosing an option, which the sort handler manages).
    var open = openDropdowns();
    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(target)) animateClose(open[i]);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;
    var open = openDropdowns();
    for (var i = 0; i < open.length; i++) animateClose(open[i]);
  });
})();
